import { render, staticRenderFns } from "./VipLogin.vue?vue&type=template&id=13668c12&scoped=true"
import script from "./VipLogin.vue?vue&type=script&lang=js"
export * from "./VipLogin.vue?vue&type=script&lang=js"
import style0 from "./VipLogin.vue?vue&type=style&index=0&id=13668c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13668c12",
  null
  
)

export default component.exports